import React, {useEffect,useState} from 'react'
import "../styles/LoginForm.css"
import {Link} from "react-router-dom";

// import TextField from '@material-ui/core/TextField'
import { Button, TextField } from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { userActions } from '../actions/user.actions'
import {useSelector,useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'

function LoginForm() {
    
    return (
        <div className="loginMain">
            <div className="loginContainer">
                <h3>NMO Admin Portal</h3>
                <h4>Enter OTP To Login</h4>
                <Formik>
                    {
                        () => (
                            <Form>
                                  <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <TextField className='mb-3' id="outlined-basic" label="OTP Number" type="number" variant="outlined" /> 
                                    {/* <div style={{position:'fixed',left:'795px',top:'316px'}}>{passwordShown?  <i class="fa fa-eye  openbtn"  onClick={handleshow}></i>: <i class="fa fa-eye-slash  openbtn"  onClick={handlePass}></i>}</div>  */}
                                    <Button variant="contained" color="primary" type="submit">Login</Button>
                                    <Link className="link" to={"/Forgot_password"}><Button variant="contained" color="primary">Resend OTP ?</Button></Link>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default LoginForm
